export enum UserErrorCode {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  SINGLE_ID_REQUIRED = 'SINGLE_ID_REQUIRED',
  INVALID_LOGIN = 'INVALID_LOGIN',
  USER_IDENTIFIER_REQUIRED = 'USER_IDENTIFIER_REQUIRED',
  EMAIL_IN_USE = 'EMAIL_IN_USE',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
}
